import { Grid } from "basis";
import { FC, ReactNode } from "react";

const RATIO_REGEX = /^(\d+)\s*\/\s*(\d+)$/;

type ResponsiveRowProps = {
  ratio?: string;
  children: ReactNode;
};

export const ResponsiveRow: FC<ResponsiveRowProps> = ({
  ratio = "1/2",
  children,
}) => {
  const match = ratio.match(RATIO_REGEX);

  if (match === null || !children) {
    console.error(`Invalid ratio: ${ratio}`);
    return null;
  }

  const firstItemColumns = Number(match[1]);
  const totalColumns = Number(match[2]);

  return (
    <Grid cols="1" cols-sm={totalColumns} rowsGap="1">
      <Grid.Item colSpan="all" colSpan-sm={`0-${firstItemColumns - 1}`}>
        {children[0]}
      </Grid.Item>
      <Grid.Item
        colSpan="all"
        colSpan-sm={`${firstItemColumns}-${totalColumns - 1}`}
      >
        {children[1]}
      </Grid.Item>
    </Grid>
  );
};
